module.exports = __webpack_public_path__ + "img/yiyuan-name1.d1f5d8a7.png";